import {
  singleConceptInterface,
  singleContractInterface,
  notesInterface,
} from 'Interfaces/FDPInterfaces/tmsInterfaces';
import {
  activeNDCInterface,
  forecastDataInterface,
  invoiceSalesSummary,
  unconstrinedForecastViewInterface,
} from 'Interfaces/FDPInterfaces/unconstrainedForecast';
import { makeAutoObservable, runInAction } from 'mobx';
import { unconstrainedForecastService } from 'services/fdp/unconstrainedForecastService';
import { tmsScreenServices } from 'services/tmsScreenServices';
import { deepCopy } from 'utils/deepCopy';

export class UnconstrainedForecastEditStore {
  directcurrentNDCIndex: number = 0;
  indirectcurrentNDCIndex: number = 0;
  isConceptLoading: boolean = false;
  isWholeSalerDateLoading: boolean = false;
  conceptDetails: singleConceptInterface | null = {
    concept: '',
    gfc: 0,
    generic_rxcui: '',
    therapeutic_category: '',
    pharmacologic_class: '',
    va_class_name: '',
    des_schedule: '',
    duration_condition: '',
    Strength: '',
  };
  contractDetails: singleContractInterface[] | [] = [
    {
      GFC: 0,
      ContractNumber: '',
      ContractType: '',
      StartDate: '',
      EndDate: '',
    },
  ];
  ActiveNDCData: activeNDCInterface[] = [];
  ActiveForecastNDC: { ndc: string; packSize: string }[] = [];
  directNDCheading: { ndc: string; packSize: string }[] = [];
  indirectNDCheading: { ndc: string; packSize: string }[] = [];
  unconstrainedForecastEdit: unconstrinedForecastViewInterface = [];
  oldunconstrainedForecastEdit: unconstrinedForecastViewInterface = [];
  isInvoiceSalesLoading: boolean = false;
  invoiceSalesSummary: invoiceSalesSummary[] = [];
  isUnconstrainedForecastNotesDataLoading: boolean = false;
  UnconstrainedForecastNotesData: notesInterface[] = [];
  isUnconstrainedNoteSaved: Set<string> = new Set();
  isUnconstrainedNoteSaving: boolean = false;
  ndcsForWhichOldValuesDisabled: Set<string> = new Set();
  isDirectMode: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  setIsDirectMode = (val: boolean) => {
    this.isDirectMode = val;
  };

  updateOldeditState = () => {
    console.log('updated the old data');
    this.oldunconstrainedForecastEdit = deepCopy(this.unconstrainedForecastEdit);
  };

  handleGetConceptDetails = async (gfc: number) => {
    runInAction(() => {
      this.isConceptLoading = true;
      // this.isUnconstrainedForecastNotesDataLoading = true;
      // this.NDCheading = [];
      this.directNDCheading = [];
      this.indirectNDCheading = [];
    });
    try {
      const data = await tmsScreenServices.getSingleGSMSConcept(gfc);
      runInAction(() => {
        this.conceptDetails = data.concept_info[0];
        this.contractDetails = data.contract_info;
      });

      if (this.conceptDetails?.gfc) {
        this.getWholeSalesDemandForecast(gfc);
        this.getInvoiceSalesSummary(gfc);
      }
    } catch (error) {
      console.error('Error while getting concept details:', error);
    } finally {
      runInAction(() => {
        this.isConceptLoading = false;
      });
    }
  };

  getInvoiceSalesSummary = async (gfc: number) => {
    this.isInvoiceSalesLoading = true;
    try {
      const response = await unconstrainedForecastService.getSalesSummaryDetails(gfc);
      this.invoiceSalesSummary = response;
    } catch (error) {
      console.log('getInvoiceSalesSummary=> ', error);
    } finally {
      this.isInvoiceSalesLoading = false;
    }
  };

  getWholeSalesDemandForecast = async (gfc: number) => {
    this.isWholeSalerDateLoading = true;
    try {
      const response = await unconstrainedForecastService.getWholeSalesDemandForecast(gfc);
      this.filterActiveNDCForGFC(response);
      this.unconstrainedForecastEdit = response;
      this.oldunconstrainedForecastEdit = response;
      // await this.fetchForecastGFCNotes(gfc);
    } catch (error) {
      console.log('getWholeSalesDemandForecast=> ', error);
    } finally {
      this.isWholeSalerDateLoading = false;
    }
  };

  fetchForecastGFCNotes = async (ndc11: string, signal?: AbortSignal) => {
    if (!ndc11) return;

    this.isUnconstrainedForecastNotesDataLoading = true;
    try {
      this.UnconstrainedForecastNotesData = await unconstrainedForecastService.getNDC11Note(
        ndc11,
        'unconstrained',
        signal
      );
    } catch (error) {
      console.log('MSPlanStore fetchMSGFCNotes => ', error);
    } finally {
      this.isUnconstrainedForecastNotesDataLoading = false;
    }
  };

  setNoteData = (idx: number, note: string) => {
    this.UnconstrainedForecastNotesData[idx].Notes = note;
  };

  removeNoteData = (idx: number) => {
    this.UnconstrainedForecastNotesData.splice(idx, 1);
  };

  saveForecastNote = async (ndc11: string, note: string, planning_type: string) => {
    this.isUnconstrainedNoteSaving = true;
    let data: notesInterface[] = [];
    try {
      const payload = {
        ndc11: ndc11,
        note: note,
        planning_type: planning_type,
      };
      data = await unconstrainedForecastService.saveNDC11Note(payload);
      if (data.length > 0) {
        this.isUnconstrainedNoteSaved.add(ndc11);
      }
    } catch (error) {
      console.log('Error saving Note=> ', error);
    } finally {
      this.UnconstrainedForecastNotesData = data;
      this.isUnconstrainedNoteSaving = false;
    }
  };

  filterActiveNDCForGFC = (data: unconstrinedForecastViewInterface) => {
    this.unconstrainedForecastEdit = [];
    // const addedEntries = new Set(); // To track added TimePeriod and NDC11 combinations
    for (let i = 1; i <= 15; i++) {
      const dt = new Date();
      dt.setMonth(dt.getMonth() + i);
      // filter wholesaler data for activeNDC
      for (const item of data) {
        if (item.SellingCategory && item?.SellingCategory.toLocaleLowerCase() === 'direct') {
          // filtering out the NDCs for direct selling category
          if (this.directNDCheading.filter(heading => heading.ndc === item.NDC11).length === 0) {
            this.directNDCheading.push({
              ndc: item.NDC11,
              packSize: String(Math.round(item.PackSize)),
            });
          }
        } else if (
          item.SellingCategory &&
          item?.SellingCategory.toLocaleLowerCase() === 'indirect'
        ) {
          // filtering out the NDCs for indirect selling category
          if (this.indirectNDCheading.filter(heading => heading.ndc === item.NDC11).length === 0) {
            this.indirectNDCheading.push({
              ndc: item.NDC11,
              packSize: String(Math.round(item.PackSize)),
            });
          }
        }
      }
    }

    if (this.directNDCheading[0]) {
      this.setIsDirectMode(true);
      this.fetchForecastGFCNotes(this.directNDCheading[0]?.ndc);
    } else {
      this.setIsDirectMode(false);
      this.fetchForecastGFCNotes(this.indirectNDCheading[0]?.ndc);
    }
  };

  updateUnconstrainedForecastEdit = async (
    unconstraintForecastDetailsParticularNdcMonthForecast: forecastDataInterface,
    ndcIndex: number,
    forecastMonthIndex: number
  ) => {
    if (
      ndcIndex < this.unconstrainedForecastEdit.length &&
      this.unconstrainedForecastEdit[ndcIndex].forecast_data.length > forecastMonthIndex
    ) {
      this.unconstrainedForecastEdit[ndcIndex].forecast_data[forecastMonthIndex] =
        unconstraintForecastDetailsParticularNdcMonthForecast;
    }
  };

  setDirectCurrentTabIndex = (newIndex: number) => {
    this.directcurrentNDCIndex = newIndex;
  };

  setIndirectCurrentTabIndex = (newIndex: number) => {
    this.indirectcurrentNDCIndex = newIndex;
  };

  resetStore = () => {
    // Tab and layout state
    this.directcurrentNDCIndex = 0;
    this.indirectcurrentNDCIndex = 0;
    this.isDirectMode = true;

    // Loading states
    this.isConceptLoading = false;
    this.isWholeSalerDateLoading = false;
    this.isInvoiceSalesLoading = false;
    this.isUnconstrainedForecastNotesDataLoading = false;
    this.isUnconstrainedNoteSaving = false;

    // Concept and contract details
    this.conceptDetails = {
      concept: '',
      gfc: 0,
      generic_rxcui: '',
      therapeutic_category: '',
      pharmacologic_class: '',
      va_class_name: '',
      des_schedule: '',
      duration_condition: '',
      Strength: '',
    };
    this.contractDetails = [
      {
        GFC: 0,
        ContractNumber: '',
        ContractType: '',
        StartDate: '',
        EndDate: '',
      },
    ];

    // NDC data
    this.ActiveNDCData = [];
    this.ActiveForecastNDC = [];
    this.directNDCheading = [];
    this.indirectNDCheading = [];

    // Forecast data
    this.unconstrainedForecastEdit = [];
    this.oldunconstrainedForecastEdit = [];

    // Notes and invoice data
    this.invoiceSalesSummary = [];
    this.UnconstrainedForecastNotesData = [];
    this.isUnconstrainedNoteSaved = new Set();
    this.ndcsForWhichOldValuesDisabled = new Set();
  };
}
